<template>
    <div class="w100 bgWhite">
        <article class="wContent center" style="padding-top: 20px">
            <!-- 顶部 start -->
            <el-row>
                <el-col :span="17">
                    <div class="quote-d-enterinfo">
                        <span class="recommend-status" v-show="enterpriseInfo.recommendStatus"></span>
                        <img :src="enterpriseInfo.logoPath || defaultLogo" alt="" class="logo">
                        <span class="inlineBlock font16 fontBold">{{ enterpriseInfo.name }}</span>
                        <small class="fontRed inlineBlock vTop textCenter" v-show="enterpriseInfo.benchmarkStatus">基</small>
                    </div>
                </el-col>
                <el-col :span="7">
                    <div>
                        <div class="quote-key-input block w100">
                            <el-input placeholder="请输入内容" v-model="searchKey">
                                <template slot="append">
                                    <a href="javascript:;" class="fontWhite" @click="findOfferByPhone(1)">搜索</a>
                                </template>
                            </el-input>
                        </div>
                        <div class="textRight quote-d-code-text pointer" @click="wxCodeDialog = true">
                            <small class="font14 fontLighter"><i class="el-icon-connection font16"></i>扫码查看手机报价信息</small>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!-- 顶部 end -->

            <div class="quote-d-line w100"></div>
            
            <el-row :gutter="20">
                <el-col :span="17">
                    <div v-show="!none">
                        <ul class="quote-d-list">
                            <li v-for="(item, index) in tableList" :key="index">
                                <span style="width: 80px" class="inlineBlock vMid font14 fontBold">{{ item.varietiesName }}</span>
                                <span style="width: 200px" class="inlineBlock vMid font14 fontBold" :title="item.attribute">{{ item.attribute }}</span>
                                <span style="width: 80px" class="inlineBlock vMid font14 fontRed fontBold">{{ item.price }}</span>
                                <span style="width: 90px" class="inlineBlock vMid font14 fontLight" :title="item.market">{{ item.market }}</span>
                                <span style="width: 80px" class="inlineBlock vMid font14 fontLight">{{ item.factory }}</span>
                                <span style="width: 120px" class="inlineBlock vMid font14 fontLight">{{ item.warehouse }}</span>
                                <span style="width: 90px" class="inlineBlock vMid font14 fontLight" :title="item.remark">{{ item.remark }}</span>
                                <span style="width: 90px" class="inlineBlock vMid font14 fontLight">{{ item.offerDate }}</span>
                            </li>
                        </ul>
                        <!-- 分页 start -->
                        <div class="textCenter" style="padding-top: 20px; padding-bottom: 20px;" v-show="true">
                            <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
                        </div>
                        <!-- 分页 end -->
                    </div>
                    <div class="textCenter font16 fontNormal" style="padding-top: 20px;" v-show="none">暂无报价信息~</div>
                </el-col>
                <el-col :span="7">
                    <div class="quote-d-right-info">
                        <span class="inlineBlock title font14 fontLight vTop  ">主营产品</span>
                        <div class="inlineBlock info-right" v-if="enterpriseInfo.varieties">
                            <el-button type="danger" size="small" v-for="(item, index) in enterpriseInfo.varieties" :key="index">{{ item.name }}</el-button>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="inlineBlock title font14 fontLight vTop">联系人</span>
                            <div class="inlineBlock info-right info-right-text fontDark fontBold font14">{{ enterpriseInfo.contacts }}</div>
                        </div>
                        <div>
                            <span class="inlineBlock title font14 fontLight vTop ">联系电话</span>
                            <div class="inlineBlock info-right info-right-text fontDark fontBold font14">{{ enterpriseInfo.phone }}</div>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="inlineBlock title font14 fontLight vTop">商家信息</span>
                            <div class="inlineBlock info-right info-right-text fontDark fontBold font14">{{ enterpriseInfo.name }}</div>
                        </div>
                        <div>
                            <span class="inlineBlock title font14 fontLight vTop ">所在地区</span>
                            <div class="inlineBlock info-right info-right-text fontNormal font14">{{ enterpriseInfo.address }}</div>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="inlineBlock title font14 fontLight vTop">企业简介</span>
                            <div class="inlineBlock info-right info-right-text fontNormal font14">{{ enterpriseInfo.introduction }}</div>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="block title font14 fontLight vTop">手机报价</span>
                            <div class="code center">
                                <span class="trade-code-border"></span>
                                <img src="../../assets/images/footer_down.png" alt="" class="w100">
                            </div>
                            <span class="block mw-modular-box fontLight font14 textCenter">扫码下载app，查询手机报价</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-dialog
            title=""
            :visible.sync="wxCodeDialog"
            width="280px">
            <div class="textCenter" style="margin-top: -20px;">
                <img :src="qrcode" alt="" style="width: 240px; height: 240px;">
                <p>打开微信，点击底部的发现</p>
                <p>使用'扫一扫'即可查看</p>
            </div>
            </el-dialog>
        </article>
    </div>
</template>
<script>
import $ from 'jquery'
import { baseUrl, getQueryString } from '../../assets/js/common'
export default {
    name: 'QuoteDetail',
    components: {},
    data() {
        
        return {
            id: '',
            defaultLogo: require('../../assets/images/enter_default_logo.png'),
            qrcode: require('../../assets/images/footer_code.png'),
            enterpriseInfo: {},
            tableList: [],
            searchKey: '',
            pageNo: 1,
            pageSize: 15,
            totalnum: 0,
            none: false,
            wxCodeDialog: false
        }
    },
    mounted () {
        this.id = getQueryString('id');
        this.findEnterByPhone();
        this.findOfferByPhone();
    },
    methods: {
        // 获取企业详细信息/api/enterprise/findByPhone/12345678
        findEnterByPhone () {
            const self = this;
            self.$get(`${baseUrl.business}/api/enterprise/findByPhone/${self.id}`, {}).then(res => {
                if (res.status == 200) {
                    self.enterpriseInfo = res.data ? res.data : {};
                    // console.log(self.enterpriseInfo)
                } else {
                    self.$message.error(res.msg)
                }
            })
        },

        // 根据手机号获取报价列表
        findOfferByPhone (type) {
            const self = this;
            self.tableList = [];
            if (type) {
                self.pageNo = 1;
                self.searchKey = self.searchKey.replace(/\s*/g,"");
            }
            self.$post(`${baseUrl.business}/api/offer/findByPhone/${self.id}/${self.pageNo - 1}/${self.pageSize}`, {searchKey: self.searchKey, status: true}).then(res => {
                if (res.status == 200) {
                    if (res.data.content.length > 0) {
                        const content = res.data.content;
                        let obj = {};
                        content.forEach((item, index) => {
                            let kvList = [];
                            obj = {
                                varietiesName: item.enterpriseVarieties.varieties.name,
                                attribute: '',
                                price: item.price,
                                market: item.enterpriseVarieties.market,
                                factory: item.enterpriseVarieties.factory,
                                warehouse: item.enterpriseVarieties.warehouse,
                                remark: item.remark,
                                offerDate: item.offerDate
                            }
                            if (item.enterpriseVarieties.attributeInfoFiledInfos.length > 0) {
                                item.enterpriseVarieties.attributeInfoFiledInfos.forEach((cItem, cIndex) => {
                                    kvList.push(cItem.fieldInfo.fieldValue);
                                })
                                obj.attribute = kvList.join(', ');
                            }
                            self.tableList.push(obj);
                        })
                        self.totalnum = res.data.totalElements;
                        self.none = false;
                    } else {
                        self.none = true;
                    }
                } else {
                    self.$message.error(res.msg);
                }
            })
        },

        // 切换分页
        handleCurrentChange (page) {
            this.pageNo = page;
            this.findOfferByPhone();
        },
    }
    
}
</script>

<style scoped>
    .quote-d-enterinfo { position: relative; }
    .quote-d-enterinfo > .logo { height: 100px; margin-right: 10px; }
    .quote-d-enterinfo > span { vertical-align: top; padding-top: 10px; }
    .quote-d-enterinfo > .recommend-status { padding: 0; position: absolute; top: 0; left: 0; width: 40px; height: 40px; background: url('../../assets/images/trade_tuijian.png') no-repeat; background-size: 100% 100%; }
    .quote-d-enterinfo small { line-height: 18px; border: 1px solid #a30000; width: 18px; height: 18px; border-radius: 1px; font-size: 12px; margin-top: 12px; margin-left: 5px;  }
    .quote-d-code-text { margin-top: 10px; }
    .quote-d-code-text i { padding-right: 5px; }
    .quote-d-line { border-top: 1px dashed #ccc; margin: 20px 0; }
    .quote-d-list { border: 1px solid #ccc; border-bottom: none; padding: 0; margin: 0; }
    .quote-d-list > li { border-bottom: 1px solid #ccc; line-height: 50px; padding-left: 8px; }
    .quote-d-list > li > span {
        padding-right: 10px;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .quote-d-right-info { border: 1px solid #ccc; border-left: 5px solid #a30000; padding: 10px 10px; margin-bottom: 20px; }
    .quote-d-right-info  .title { width: 100px; }
    .quote-d-right-info .info-right { width: 209px; }
    .quote-d-right-info .info-right .el-button--danger,
    .quote-d-right-info .info-right .el-button--danger:hover { margin-left: 0; margin-right: 10px; margin-bottom: 10px; background: #a30000; border-color: #a30000; }
    .info-right-text { line-height: 20px; }
    .quote-d-right-info .code { width: 100px; margin-top: 20px; position: relative; }
    .quote-d-right-info .code .trade-code-border { width: 130px; height: 130px; position: absolute; top: -16px; left: -16px; background: url('../../assets/images/quote_kuang.png') no-repeat; background-size: 100% 100%; }
    
</style> 